function placeholder(value: any): string {
  return value || '-';
}

export default placeholder;
